'use client'
import Presences from './presences';
import Registrations from './registrations';

export default function PageProfile() {

    return (
        <section>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
                <div className="relative pt-32 pb-10">
                    <div className="mx-auto">
                        {/* Presences display */}
                        <Presences />
                        {/* Registrations display */}
                        <Registrations />
                    </div>
                </div>
            </div>
        </section>
    );
}
